import { getErrorMessage } from '../../errorBuilder';
import { post } from '../../service';
import { UrlBuilder } from '../../urlBuilder';

export const getUsers = async (payload) => {
  const builder = new UrlBuilder(`/manage/clients/list-users`);

  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const createUser = async (payload) => {
  const builder = new UrlBuilder(`/manage/clients/create-user`);

  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const createUserAsRoot = async (payload) => {
  const builder = new UrlBuilder(`/clients/create-user`);

  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const deleteUser = async (payload) => {
  const builder = new UrlBuilder(`/manage/clients/delete-user`);

  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};
